<template>
  <div>
    <c-tab
      type="tabcard"
      align="left"
      :inlineLabel="true"
      :dense="true"
      :tabItems="child.tabItems"
      :height.sync="tabHeight"
      v-model="child.tab"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :key="tab.key"
          :patrol="patrol"
          :resultItems.sync="resultItems"
          :colorItemse.sync="colorItems"
          :place.sync="tab.place"
          :eventScroll.sync="eventScroll"
          :currentTab.sync="currentTab"
          :contentHeight="contentHeight"
          @tranStep="tranStep"
          @research="research"
          @closePopup="closePopup"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
// import { uid } from 'quasar'
export default {
  name: 'patrol-place',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        saiPatrolId: '',
        research: '',
      }),
    },
    patrol: {
      type: Object,
      default: () => ({
        saiPatrolId: '',  // 순회점검 일련번호
        plantCd: '',  // 사업장 코드
        patrolName: '',  // 순회명
        patrolStartDate: '',  // 순회시작일
        patrolEndDate: '',  // 순회종료일
        deptCd: '',  // 점검부서 코드
        deptName: '',  // 점검부서
        patrolResultCd: null,  // 특이사항
        patrolResultSummary: '',  // 순회결과요약
        patrolStepCd: null,  // 진행상태
        regUserId: '',  //
        places: [],
        deletePlaces: [],
      }),
    },
    eventScroll: {
      type: Object,
      default(){
        return {
          position: null,
          direction: null,
          save: null,
          isSave: false,
        }
      },
    },
    colorItems: {
      type: Array,
      default: () => [],
    },
    resultItems: {
      type: Array,
      default: () => [],
    },
    child: {
      type: Object,
      default: () => ({
        tab: '',
        tabItems: [],
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: true,
      currentTab: {
        saiPatrolPlaceId: '',
      }
    };
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 60) + 'px';
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      // list setting
      if (this.tabItems && this.tabItems.length > 0) {
        this.currentTab.saiPatrolPlaceId = this.tabItems[0].place.saiPatrolPlaceId;
      }
    },
    tranStep() {
      this.$emit('transInfo', this.patrol.saiPatrolId)
    },
    research() {
      this.$emit('research')
    },
    tabClick(tab) {
      this.currentTab.saiPatrolPlaceId = tab.place.saiPatrolPlaceId;
    },
    closePopup() {
      this.$emit('closePopup')
    },
  }
};
</script>
